export const AREAS = [
  {
    slug: "handyman-mumbles",
    area: "Mumbles",
    postcode: "SA3",
    landmark: "Mumbles Pier and Oystermouth Castle",
    metaTitle: "Handyman in Mumbles (SA3) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Trusted handyman in Mumbles, Swansea (SA3). Flat-pack assembly, TV mounting, painting, gutters & repairs. £60 minimum per job. Book your local handyman online.",
    blurb:
      "From the seafront homes near Mumbles Pier to the streets around Oystermouth Castle, we're the reliable local handyman Mumbles residents call for jobs done properly. The salty coastal air is tough on gutters, fences and window fittings — and we know exactly how to keep SA3 homes in top shape.",
  },
  {
    slug: "handyman-sketty",
    area: "Sketty",
    postcode: "SA2",
    landmark: "Singleton Park and Sketty Cross",
    metaTitle: "Handyman in Sketty (SA2) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Reliable handyman in Sketty, Swansea (SA2). Furniture assembly, shelving, painting, door repairs & odd jobs. £60 minimum per job. Enquire with your local handyman.",
    blurb:
      "Serving the family homes and student lets around Singleton Park and Sketty Cross, we handle everything from flat-pack builds to shelving, painting and repairs. Sketty (SA2) is one of our busiest patches, so you'll never wait long for a dependable local handyman.",
  },
  {
    slug: "handyman-gower",
    area: "Gower",
    postcode: "SA3",
    landmark: "Rhossili Bay and Three Cliffs Bay",
    metaTitle: "Handyman on the Gower Peninsula (SA3) | DIY Services | FIT N FIX",
    metaDescription:
      "Local handyman across the Gower peninsula (SA3). Fencing, decking, gutters, flat-pack & repairs for homes and holiday lets. £60 minimum per job. Book online.",
    blurb:
      "From Rhossili Bay to Three Cliffs and the villages in between, we look after homes and holiday lets right across the Gower peninsula. Exposed coastal properties take a battering from the weather, so fencing, decking and gutter work are our bread and butter out here in SA3.",
  },
  {
    slug: "handyman-swansea-city-centre",
    area: "Swansea City Centre",
    postcode: "SA1",
    landmark: "the Marina and Wind Street",
    metaTitle: "Handyman in Swansea City Centre (SA1) | DIY Services | FIT N FIX",
    metaDescription:
      "City-centre handyman covering Swansea SA1 — the Marina, Maritime Quarter & Wind Street. Flat-pack, TV mounting, repairs & more. £60 minimum. Enquire online.",
    blurb:
      "We cover the apartments and townhouses around the Marina, Maritime Quarter and Wind Street. City-centre living means clever use of space — so flat-pack assembly, wall-mounted TVs and smart storage solutions are exactly what SA1 residents ask us for most.",
  },
  {
    slug: "handyman-uplands",
    area: "Uplands",
    postcode: "SA2",
    landmark: "Cwmdonkin Park and Uplands Crescent",
    metaTitle: "Handyman in Uplands (SA2) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Local handyman in Uplands, Swansea (SA2). Painting, gutter cleaning, sash & period-property repairs, flat-pack & odd jobs. £60 minimum per job. Book online.",
    blurb:
      "The characterful period homes around Cwmdonkin Park and Uplands Crescent need a handyman who respects their charm. From decorating high Victorian ceilings to clearing leaf-filled gutters, we keep Uplands (SA2) homes looking their best.",
  },
  {
    slug: "handyman-morriston",
    area: "Morriston",
    postcode: "SA6",
    landmark: "Morriston Cross and Tabernacle Chapel",
    metaTitle: "Handyman in Morriston (SA6) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Dependable handyman in Morriston, Swansea (SA6). Fencing, flat-pack, painting, door & window repairs and general jobs. £60 minimum per job. Enquire online.",
    blurb:
      "Covering the streets around Morriston Cross and the landmark Tabernacle Chapel, we're the go-to local handyman for SA6 homes. Fencing, flat-pack assembly, painting and general repairs — whatever's on your list, we'll get it sorted.",
  },
  {
    slug: "handyman-gorseinon",
    area: "Gorseinon",
    postcode: "SA4",
    landmark: "Gorseinon town centre and Penllergaer woods",
    metaTitle: "Handyman in Gorseinon (SA4) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Friendly local handyman in Gorseinon, Swansea (SA4). Flat-pack, shelving, gutters, garden repairs & odd jobs. £60 minimum per job. Book your handyman online.",
    blurb:
      "From Gorseinon town centre out towards Penllergaer, we serve homes across SA4 with reliable, tidy handyman work. Flat-pack assembly, shelving, gutter clearing and garden repairs are all part of the day-to-day out here.",
  },
  {
    slug: "handyman-killay",
    area: "Killay",
    postcode: "SA2",
    landmark: "Killay shopping precinct and Clyne Valley Country Park",
    metaTitle: "Handyman in Killay (SA2) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Local handyman in Killay, Swansea (SA2). Furniture assembly, TV mounting, painting, repairs & decking near Clyne Valley. £60 minimum per job. Enquire online.",
    blurb:
      "Serving homes near the Killay precinct and Clyne Valley Country Park, we handle everything from flat-pack furniture and TV mounting to decking and repairs. Killay (SA2) households trust us for prompt, dependable local service.",
  },
  {
    slug: "handyman-llansamlet",
    area: "Llansamlet",
    postcode: "SA7",
    landmark: "Enterprise Park and Parc Tawe",
    metaTitle: "Handyman in Llansamlet (SA7) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Reliable local handyman in Llansamlet, Swansea (SA7). Flat-pack, TV mounting, painting, repairs & maintenance. £60 minimum per job. Book your handyman online.",
    blurb:
      "Covering the homes around Enterprise Park and out towards Parc Tawe, we're the dependable local handyman for Llansamlet (SA7). From flat-pack assembly to repairs and property maintenance, we keep the job simple and the finish tidy.",
  },
  {
    slug: "handyman-gowerton",
    area: "Gowerton",
    postcode: "SA4",
    landmark: "Gowerton station and the gateway to Gower",
    metaTitle: "Handyman in Gowerton (SA4) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Trusted handyman in Gowerton, Swansea (SA4). Furniture assembly, painting, fencing, repairs & maintenance. £60 minimum per job. Enquire with your local handyman.",
    blurb:
      "As the gateway to the Gower peninsula, Gowerton (SA4) sits right on our patch. From the streets around the station to the surrounding lanes, we handle flat-pack, painting, fencing panels and all-round repairs for local homes.",
  },
  {
    slug: "handyman-pontarddulais",
    area: "Pontarddulais",
    postcode: "SA4",
    landmark: "the Bont and Coed Bach Park",
    metaTitle: "Handyman in Pontarddulais (SA4) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Friendly local handyman in Pontarddulais, Swansea (SA4). Flat-pack, shelving, painting, garden & repair jobs. £60 minimum per job. Book your handyman online.",
    blurb:
      "From the heart of 'the Bont' out to Coed Bach Park, we serve Pontarddulais (SA4) with reliable, tidy handyman work. Whatever's on your list — assembly, shelving, painting or repairs — we'll get it sorted.",
  },
  {
    slug: "handyman-bishopston",
    area: "Bishopston",
    postcode: "SA3",
    landmark: "Bishopston Valley and Pwlldu Bay",
    metaTitle: "Handyman in Bishopston (SA3) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Local handyman in Bishopston, Gower (SA3). Furniture assembly, painting, fencing, door repairs & maintenance. £60 minimum per job. Enquire online today.",
    blurb:
      "Serving the Gower homes around Bishopston Valley and down towards Pwlldu Bay, we're the trusted local handyman for SA3. Coastal properties need dependable upkeep, and we keep Bishopston homes in great shape.",
  },
  {
    slug: "handyman-clydach",
    area: "Clydach",
    postcode: "SA6",
    landmark: "Clydach village and the Swansea Valley",
    metaTitle: "Handyman in Clydach (SA6) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Dependable handyman in Clydach, Swansea (SA6). Flat-pack, painting, fencing, repairs & property maintenance. £60 minimum per job. Book your local handyman.",
    blurb:
      "Covering Clydach village and the lower Swansea Valley, we're the go-to local handyman for SA6. Flat-pack, painting, fencing panels and general repairs — all handled promptly and left tidy.",
  },
  {
    slug: "handyman-penllergaer",
    area: "Penllergaer",
    postcode: "SA4",
    landmark: "Penllergare Valley Woods",
    metaTitle: "Handyman in Penllergaer (SA4) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Reliable handyman in Penllergaer, Swansea (SA4). Assembly, shelving, painting, garden & repair jobs near Penllergare Woods. £60 minimum per job. Enquire online.",
    blurb:
      "From the homes around Penllergare Valley Woods, we keep Penllergaer (SA4) properties spotless with reliable handyman work — flat-pack, painting, shelving, fencing and everyday repairs.",
  },
  {
    slug: "handyman-loughor",
    area: "Loughor",
    postcode: "SA4",
    landmark: "Loughor Castle and the estuary",
    metaTitle: "Handyman in Loughor (SA4) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Local handyman in Loughor, Swansea (SA4). Furniture assembly, painting, fencing, repairs & maintenance near the estuary. £60 minimum per job. Book online.",
    blurb:
      "Serving the homes around Loughor Castle and the estuary, we're the dependable local handyman for SA4. From assembly and painting to fencing and repairs, we make home jobs easy.",
  },
  {
    slug: "handyman-west-cross",
    area: "West Cross",
    postcode: "SA3",
    landmark: "Swansea Bay seafront and Blackpill",
    metaTitle: "Handyman in West Cross (SA3) | Local DIY Services | FIT N FIX",
    metaDescription:
      "Trusted handyman in West Cross, Swansea (SA3). Flat-pack, TV mounting, painting, gutters & repairs near Swansea Bay. £60 minimum per job. Enquire online.",
    blurb:
      "Right along the Swansea Bay seafront between Blackpill and the Mumbles, West Cross (SA3) is a favourite patch of ours. We handle flat-pack, TV mounting, painting, gutters and repairs for seafront and residential homes alike.",
  },
];

export const getArea = (slug) => AREAS.find((a) => a.slug === slug);
